(function () {
  if (window.MOX_CART_DRAWER_MIN_PURCHASE) {
    window.MOX_CART_DRAWER_MIN_PURCHASE.syncRoot();
    window.MOX_CART_DRAWER_MIN_PURCHASE.refresh();
    return;
  }

  const DEFAULT_THRESHOLD = 800000;
  const DEFAULT_MESSAGE = '¡Hola, Tu monto actual en el carrito es de [CURRENT_AMOUNT]. Por ser un sitio mayorista, el valor mínimo de la compra es de [MIN_AMOUNT]. Para finalizar tu compra agrega el valor mínimo requerido.';
  const SELECTORS = {
    config: '[data-cart-drawer-minimum-purchase-config]',
    bannerText: '.hdt-mini-cart__minimum-purchase-text',
    alertDialog: '[data-mox-min-alert-dialog]',
    alertRoot: '[data-mox-min-alert-root]',
    alertMessage: '[data-mox-min-alert-message]',
    alertClose: '[data-mox-min-alert-close]',
    checkoutButton: '.hdt-mini-cart__btn-checkout[name="checkout"], .hdt-main-cart__button-checkout[name="checkout"]',
    totalAmount: '[data-er-cart-total-price]',
    fallbackTotalAmount: '[data-cart-subtotal], .hdt-page-cart__totals .hdt-totals__total-value'
  };

  const state = {
    fallbackSubtotalAmount: null,
    currentCurrencyCode: null
  };

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = String(value == null ? '' : value);
    return div.innerHTML;
  }

  function normalizeCurrencyCode(value) {
    const currencyCode = String(value || '').trim().toUpperCase();
    return /^[A-Z]{3}$/.test(currencyCode) ? currencyCode : '';
  }

  function getTotalAmountNode() {
    return document.querySelector(SELECTORS.totalAmount);
  }

  function getFallbackTotalAmountNode() {
    return document.querySelector(SELECTORS.fallbackTotalAmount);
  }

  function readCurrencyCodeFromNode(node) {
    if (!node) return '';

    const dataCurrencyCode = normalizeCurrencyCode(node.dataset?.hdtCurrency || node.getAttribute('data-hdt-currency'));
    if (dataCurrencyCode) return dataCurrencyCode;

    const textCurrencyMatch = String(node.textContent || '').match(/\b([A-Z]{3})\b(?!.*\b[A-Z]{3}\b)/);
    return normalizeCurrencyCode(textCurrencyMatch ? textCurrencyMatch[1] : '');
  }

  function updateCurrentCurrencyCode(nextCurrencyCode) {
    const normalizedCurrencyCode = normalizeCurrencyCode(nextCurrencyCode);
    if (normalizedCurrencyCode) {
      state.currentCurrencyCode = normalizedCurrencyCode;
    }
    return state.currentCurrencyCode;
  }

  function detectCurrentCurrencyCode() {
    return updateCurrentCurrencyCode(
      readCurrencyCodeFromNode(getTotalAmountNode())
      || readCurrencyCodeFromNode(getFallbackTotalAmountNode())
      || window.Shopify?.currency?.active
      || getConfigNode()?.dataset?.currentCurrencyCode
      || 'COP'
    );
  }

  function getCurrentCurrencyCode() {
    return detectCurrentCurrencyCode() || 'COP';
  }

  function normalizeMinorUnits(amount) {
    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount) || numericAmount <= 0) return 0;
    return Math.floor(numericAmount / 100);
  }

  function formatAmountWithDots(amount) {
    return String(Math.max(0, Math.floor(Number(amount) || 0))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function buildAmountLabel(amount, currencyCode) {
    return `$ ${formatAmountWithDots(amount)} ${String(currencyCode || getCurrentCurrencyCode()).toUpperCase()}`;
  }

  function parseRenderedAmount(text) {
    const rawValue = String(text || '').trim();
    const digits = rawValue.replace(/[^\d]/g, '');
    if (!digits) return 0;

    const lastDotIndex = rawValue.lastIndexOf('.');
    const lastCommaIndex = rawValue.lastIndexOf(',');
    const lastSeparatorIndex = Math.max(lastDotIndex, lastCommaIndex);

    if (lastSeparatorIndex >= 0) {
      const digitsAfterLastSeparator = rawValue
        .substring(lastSeparatorIndex + 1)
        .replace(/[^\d]/g, '');

      if (digitsAfterLastSeparator.length === 2) {
        return Math.floor(parseInt(digits, 10) / 100);
      }

      if (digitsAfterLastSeparator.length >= 3) {
        return parseInt(digits, 10);
      }
    }

    return parseInt(digits, 10);
  }

  function getConfigNode() {
    return document.querySelector(SELECTORS.config);
  }

  function createAlertRoot() {
    const root = document.createElement('div');
    root.className = 'mox-min-alert';
    root.setAttribute('data-mox-min-alert-root', '');
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = [
      '<div class="mox-min-alert__box" role="alert" aria-live="assertive">',
      '<div class="mox-min-alert__icon" aria-hidden="true">⚠️</div>',
      '<div class="mox-min-alert__message" data-mox-min-alert-message></div>',
      '<button type="button" class="mox-min-alert__close" data-mox-min-alert-close aria-label="Cerrar">×</button>',
      '</div>'
    ].join('');
    return root;
  }

  function createAlertDialog() {
    const dialog = document.createElement('dialog');
    dialog.className = 'hdt-dialog mox-min-alert-dialog';
    dialog.setAttribute('data-mox-min-alert-dialog', '');
    dialog.setAttribute('scroll-lock', '');
    dialog.appendChild(createAlertRoot());
    document.body.appendChild(dialog);
    return dialog;
  }

  function getAlertDialog() {
    const dialogs = Array.from(document.querySelectorAll(SELECTORS.alertDialog));
    let dialog = dialogs[0];

    if (dialogs.length > 1) {
      dialogs.slice(1).forEach(function (node) {
        node.remove();
      });
    }

    if (!dialog) {
      dialog = createAlertDialog();
    }

    if (dialog.parentNode !== document.body) {
      document.body.appendChild(dialog);
    }

    return dialog;
  }

  function normalizeAlertMessage(rawMessage) {
    if (typeof rawMessage === 'object' && rawMessage && rawMessage.minimum_purchase_alert_message) {
      return String(rawMessage.minimum_purchase_alert_message);
    }

    if (typeof rawMessage === 'string') {
      const trimmed = rawMessage.trim();
      if (!trimmed) return DEFAULT_MESSAGE;

      if (trimmed.startsWith('{') && trimmed.includes('minimum_purchase_alert_message')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (parsed && typeof parsed.minimum_purchase_alert_message === 'string' && parsed.minimum_purchase_alert_message.trim()) {
            return parsed.minimum_purchase_alert_message;
          }
        } catch (_error) {
          return trimmed;
        }
      }

      return trimmed;
    }

    return DEFAULT_MESSAGE;
  }

  function getConfig() {
    const node = getConfigNode();
    if (!node) {
      return {
        minimum_purchase_threshold: DEFAULT_THRESHOLD,
        minimum_purchase_message: 'Compra mínima de [AMOUNT]',
        minimum_purchase_alert_message: DEFAULT_MESSAGE,
        minimum_purchase_amount_label: buildAmountLabel(DEFAULT_THRESHOLD),
        current_currency_code: getCurrentCurrencyCode(),
        customer_name: 'Cliente',
        is_pos_customer: false,
        cart_total_price: 0
      };
    }

    try {
      const parsed = JSON.parse(node.textContent);
      return {
        minimum_purchase_threshold: Number(parsed.minimum_purchase_threshold ?? DEFAULT_THRESHOLD),
        minimum_purchase_message: parsed.minimum_purchase_message || 'Compra mínima de [AMOUNT]',
        minimum_purchase_alert_message: normalizeAlertMessage(parsed.minimum_purchase_alert_message),
        minimum_purchase_amount_label: parsed.minimum_purchase_amount_label || buildAmountLabel(parsed.minimum_purchase_threshold ?? DEFAULT_THRESHOLD, parsed.current_currency_code),
        current_currency_code: parsed.current_currency_code || getCurrentCurrencyCode(),
        customer_name: parsed.customer_name || 'Cliente',
        is_pos_customer: Boolean(parsed.is_pos_customer),
        cart_total_price: Number(parsed.cart_total_price || 0)
      };
    } catch (_error) {
      return {
        minimum_purchase_threshold: DEFAULT_THRESHOLD,
        minimum_purchase_message: 'Compra mínima de [AMOUNT]',
        minimum_purchase_alert_message: DEFAULT_MESSAGE,
        minimum_purchase_amount_label: buildAmountLabel(DEFAULT_THRESHOLD),
        current_currency_code: getCurrentCurrencyCode(),
        customer_name: 'Cliente',
        is_pos_customer: false,
        cart_total_price: 0
      };
    }
  }

  function getAlertRoot() {
    const dialog = getAlertDialog();
    const roots = Array.from(document.querySelectorAll(SELECTORS.alertRoot));
    let root = roots.find(function (node) {
      return node.parentNode === dialog;
    }) || roots[0];

    if (root) {
      roots.forEach(function (node) {
        if (node !== root) node.remove();
      });
      if (root.parentNode !== dialog) {
        dialog.appendChild(root);
      }
      return root;
    }

    root = createAlertRoot();
    dialog.appendChild(root);
    return root;
  }

  function closeAlert() {
    const dialog = getAlertDialog();
    const root = getAlertRoot();
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    if (dialog.open) {
      dialog.close();
    }
  }

  function getSubtotalTextFromDom() {
    const totalNode = document.querySelector(SELECTORS.totalAmount);
    if (totalNode && totalNode.textContent && totalNode.textContent.trim()) {
      return totalNode.textContent.trim();
    }

    const fallbackNode = document.querySelector(SELECTORS.fallbackTotalAmount);
    if (fallbackNode && fallbackNode.textContent && fallbackNode.textContent.trim()) {
      return fallbackNode.textContent.trim();
    }

    return '';
  }

  function getSubtotalAmountFromDom() {
    const subtotalText = getSubtotalTextFromDom();
    if (!subtotalText) return null;
    return parseRenderedAmount(subtotalText);
  }

  function getSubtotalAmount() {
    const domSubtotalAmount = getSubtotalAmountFromDom();
    if (Number.isFinite(domSubtotalAmount)) return domSubtotalAmount;
    if (Number.isFinite(state.fallbackSubtotalAmount)) return state.fallbackSubtotalAmount;
    const config = getConfig();
    return normalizeMinorUnits(config.cart_total_price || 0);
  }

  function getMinimumAmountLabel() {
    const config = getConfig();
    return buildAmountLabel(config.minimum_purchase_threshold ?? DEFAULT_THRESHOLD, getCurrentCurrencyCode());
  }

  function buildBannerText() {
    const config = getConfig();
    return String(config.minimum_purchase_message || 'Compra mínima de [AMOUNT]').replace(/\[AMOUNT\]/g, getMinimumAmountLabel());
  }

  function renderBannerText() {
    const bannerNode = document.querySelector(SELECTORS.bannerText);
    if (!bannerNode) return;
    bannerNode.textContent = buildBannerText();
  }

  function getCurrentAmountLabel() {
    const subtotalText = getSubtotalTextFromDom();
    if (subtotalText) {
      return buildAmountLabel(parseRenderedAmount(subtotalText), getCurrentCurrencyCode());
    }

    return buildAmountLabel(getSubtotalAmount(), getCurrentCurrencyCode());
  }

  function shouldBlockCheckout() {
    const config = getConfig();
    const threshold = Number.isFinite(config.minimum_purchase_threshold) ? config.minimum_purchase_threshold : DEFAULT_THRESHOLD;

    if (config.is_pos_customer || threshold <= 0) return false;

    return getSubtotalAmount() < threshold;
  }

  function buildAlertMessage() {
    const config = getConfig();
    const template = normalizeAlertMessage(config.minimum_purchase_alert_message || DEFAULT_MESSAGE);
    const customerName = escapeHtml(config.customer_name || 'Cliente');
    const currentAmount = escapeHtml(getCurrentAmountLabel());
    const minAmount = escapeHtml(getMinimumAmountLabel());
    const markerCustomer = '__MARKER_CUSTOMER__';
    const markerCurrent = '__MARKER_CURRENT__';
    const markerMinimum = '__MARKER_MINIMUM__';

    const escapedTemplate = escapeHtml(
      template
        .replace(/\[CUSTOMER\]/g, markerCustomer)
        .replace(/\[CURRENT_AMOUNT\]/g, markerCurrent)
        .replace(/\[MIN_AMOUNT\]/g, markerMinimum)
    );

    return escapedTemplate
      .replace(new RegExp(markerCustomer, 'g'), `<strong>${customerName}</strong>`)
      .replace(new RegExp(markerCurrent, 'g'), `<strong>${currentAmount}</strong>`)
      .replace(new RegExp(markerMinimum, 'g'), `<strong>${minAmount}</strong>`);
  }

  function renderAlertMessage() {
    const root = getAlertRoot();
    const messageNode = root.querySelector(SELECTORS.alertMessage);
    if (messageNode) {
      messageNode.innerHTML = buildAlertMessage();
    }
  }

  function openAlert() {
    const dialog = getAlertDialog();
    const root = getAlertRoot();
    renderAlertMessage();

    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    if (!dialog.open) {
      dialog.showModal();
    }
  }

  function syncFallbackSubtotal(nextSubtotalAmount) {
    if (Number.isFinite(nextSubtotalAmount)) {
      state.fallbackSubtotalAmount = nextSubtotalAmount;
      return;
    }

    const domSubtotalAmount = getSubtotalAmountFromDom();
    if (Number.isFinite(domSubtotalAmount)) {
      state.fallbackSubtotalAmount = domSubtotalAmount;
      return;
    }

    state.fallbackSubtotalAmount = normalizeMinorUnits(getConfig().cart_total_price || 0);
  }

  function refreshSubtotalFromEvent(event) {
    const nextSubtotal = Number(event?.detail?.cartData?.total_price);
    syncFallbackSubtotal(Number.isFinite(nextSubtotal) ? normalizeMinorUnits(nextSubtotal) : null);

    if (!shouldBlockCheckout()) {
      closeAlert();
    }
  }

  function refreshSubtotalFromCurrencyChange() {
    window.requestAnimationFrame(function () {
      detectCurrentCurrencyCode();
      syncFallbackSubtotal(null);
      renderBannerText();

      if (getAlertDialog().open) {
        renderAlertMessage();
      }

      if (!shouldBlockCheckout()) {
        closeAlert();
      }
    });
  }

  function handleCheckoutAttempt(event) {
    if (!shouldBlockCheckout()) {
      closeAlert();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    openAlert();
  }

  document.addEventListener('cart:update', refreshSubtotalFromEvent);
  document.addEventListener('currency:update', refreshSubtotalFromCurrencyChange);

  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest(SELECTORS.alertClose);
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      closeAlert();
      return;
    }

    const checkoutButton = event.target.closest(SELECTORS.checkoutButton);
    if (!checkoutButton) return;

    handleCheckoutAttempt(event);
  }, true);

  document.addEventListener('submit', function (event) {
    const submitter = event.submitter;
    if (!submitter || !submitter.matches(SELECTORS.checkoutButton)) return;

    handleCheckoutAttempt(event);
  }, true);

  window.MOX_CART_DRAWER_MIN_PURCHASE = {
    syncRoot: function () {
      getAlertRoot();
    },
    refresh: function () {
      getAlertRoot();
      detectCurrentCurrencyCode();
      renderBannerText();
      syncFallbackSubtotal(null);
      if (!shouldBlockCheckout()) {
        closeAlert();
      }
    }
  };

  window.MOX_CART_DRAWER_MIN_PURCHASE.refresh();
})();
